// extracted by mini-css-extract-plugin
export var articleCard = "articleCard-module--article-card--d3ee4";
export var articleLink = "articleCard-module--article-link--0a1e4";
export var category = "articleCard-module--category--16001";
export var image = "articleCard-module--image--474ad";
export var imageWrapper = "articleCard-module--image-wrapper--b6e37";